<form
  *ngIf="loginForm"
  class="form-container"
  name="form"
  [formGroup]="loginForm"
  (ngSubmit)="sendPasswordToUserPhone(loginForm.value)"
  data-qa-form="login-by-sms"
>
  <div class="card-content">
    <tax-input
      [labelText]="'user.form.login'"
      formControlName="login"
      [autofocus]="true"
      [tabindex]="1"
      data-qa-input="login"
    ></tax-input>

    <button
      class="button_blue"
      [disabled]="loginForm.invalid || this.loading"
      data-qa-button="login-by-sms"
    >
      {{ 'login.sms.button' | translate }}
    </button>
  </div>

  <div class="card-pic">
    <svg-icon key="phone"></svg-icon>
    <div class="image-description">{{ 'login.sms.description' | translate }}</div>
  </div>
</form>
